<!--
  label-has-associated-control cannot see through content projection: the
  control arrives via <ng-content /> below, so no static analysis of this
  template can find it. The association is real and asserted rather than
  assumed — bz-form-field.spec.ts checks the browser's own view of it,
  `control().labels[0] === labelEl()`, with bz-input's <input> three levels
  down.

  The residual risk the rule is pointing at is real but inherent to a
  slot-based API: a caller who projects something that is not a form control
  gets a label that labels nothing. mat-label has the same shape.
-->
<!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -->
<label class="bz-form-field__labelled">
  @if (label()) {
    <span class="bz-form-field__label">
      {{ label() }}@if (required()) {<span class="bz-form-field__required" aria-hidden="true">*</span>}
    </span>
  }

  <ng-content />
</label>

@if (message(); as message) {
  <!--
    Outside the <label> on purpose: a label's accessible name is its whole
    text content, so a hint inside it would be read as part of the field's
    name. role="alert" only on the error, so it is announced when it appears —
    a hint is not news and should not interrupt.
  -->
  <p
    class="bz-form-field__message"
    [class.bz-form-field__message--error]="!!error()"
    [attr.role]="error() ? 'alert' : null"
  >
    {{ message }}
  </p>
}
